import { TreeMatch } from '../models/bracket-tree.model';

function getFlatMatches(match: TreeMatch) {
  // TODO: Clean up this method
  const prev = match.previous.map((m) => getFlatMatches(m));
  let all = [match];
  prev.forEach((p) => {
    const flat = (p as any).flat(Infinity);
    all = all.concat(flat);
  });

  return all;
}

function isWholeNumber(n: number) {
  const result = n - Math.floor(n) === 0;
  return result;
}

function isMultiple(n1: number, n2: number) {
  const q = n1 / n2;
  return isWholeNumber(q);
}

// Note: This mutates the tree object
export function padWithFakes(root: TreeMatch) {
  const flatMatches = getFlatMatches(root);

  // Highest layer (aka rount 1 or play-ins)
  const highestLayer = Math.max(...flatMatches.map((m) => m.layer));
  const highestLayerMatches = flatMatches.filter(
    (m) => m.layer === highestLayer
  );

  // Second to highest layer (aka round 2 - or round 1 if there is a play-in round)
  const previousLayerMatches = flatMatches.filter(
    (m) => m.layer === highestLayer - 1
  );

  const capMatches = flatMatches.filter((m) => m.layer === highestLayer - 1);

  // Used for determining if we need to add "fake" (hidden) matches for bracket spacing
  // This indicates the maximum "match height" of the play-in round.
  // If match height is 2, then any previous play-in matches only containing 1 match
  // will be padded to have 2 (one being fake)
  const highestPlayInMatchCount = Math.max(
    ...capMatches.map((m) => m.previous.length)
  );

  const log = Math.log2(highestLayerMatches.length);
  if (
    log !== 0 &&
    log !== 1 &&
    isWholeNumber(log) &&
    !isMultiple(previousLayerMatches.length, highestLayerMatches.length)
  ) {
    // Doesn't need any padding because this is a perfect bracket
    return { highestPlayInMatchCount: highestPlayInMatchCount };
  }

  capMatches.forEach((m) => {
    // Add fakes
    const initialPrevious = m.previous.length;
    for (let i = 0; i < highestPlayInMatchCount - initialPrevious; i++) {
      // This mutates the original
      (m.previous as any[]).push({ fake: true });
    }

    return m;
  });

  return {
    highestPlayInMatchCount: highestPlayInMatchCount,
  };
}
